import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AnalyticsReference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M3 15V16.5H6.4395L1.5 21.4395 2.5605 22.5 7.5 17.5605V21H9V15H3zM22.5 3H17.25V4.5H19.9394L14.25 10.1894 11.0302 6.96975C10.8896 6.82915 10.6989 6.75016 10.5 6.75016 10.3011 6.75016 10.1104 6.82915 9.96975 6.96975L6 10.9394 7.06065 12 10.5 8.56057 13.7197 11.7802C13.8604 11.9209 14.0511 11.9998 14.25 11.9998 14.4489 11.9998 14.6396 11.9209 14.7803 11.7802L21 5.56058V8.25H22.5V3zM22.5 21H12V22.5H22.5V21zM3 1.5H1.5V12H3V1.5z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AnalyticsReference.vue"]]);
